import React from 'react'
import './product-card.css'
import { Link } from 'react-router-dom'

const Product_card = (props) => {
  return (
    <>
      {/* <section className='Product_card'>
        <div className='img_div'>
          <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/products/product1.png'} alt="product-image" />
        </div>
        <div className='overlaybg'></div>
        <div className='prd_details'>
          <p className='modelno'>Cassida CS-225</p>
          <p className='prd_name'>1 New Old Rupees Counter & Sorting Machine</p>
          <div className='btndiv'>
            <Link to={'/'}>
              <button className='viewbtn'>View Details</button>
            </Link>
          </div>
        </div>
      </section> */}

      <section className='Product_card'>
        <div className='img_div'>
          <img className='prod_img' src={props.image} alt="product-image" />
        </div>
        <div className='overlaybg'></div>
        <div className='prd_details'>
          <p className='modelno'>{props.modelno}</p>
          <p className='prd_name'>{props.product_name}</p>
          <div className='btndiv'>
            <Link to={props.link}>
              <button className='viewbtn'>View Details</button>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default Product_card